import { Recipe } from '../types/recipe';

export function getWeeklyRecipes(recipes: Recipe[]): Recipe[] {
  // Filter out sweet recipes (desserts) for weekly recipes
  const filteredRecipes = recipes.filter(recipe => 
    recipe.category !== 'Dessert' && 
    !recipe.name.toLowerCase().includes('gâteau') &&
    !recipe.name.toLowerCase().includes('crêpes') &&
    !recipe.name.toLowerCase().includes('pain perdu') &&
    !recipe.name.toLowerCase().includes('sucré')
  );

  // Get the current date
  const now = new Date();
  
  // Calculate the start of the current week (Sunday)
  const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
  const sundayOfCurrentWeek = new Date(now);
  sundayOfCurrentWeek.setDate(now.getDate() - currentDay);
  sundayOfCurrentWeek.setHours(0, 0, 0, 0); // Reset to start of day
  
  // Get the week number since epoch (in weeks)
  const epochStart = new Date(1970, 0, 4); // January 4, 1970 was a Sunday
  const weeksSinceEpoch = Math.floor((sundayOfCurrentWeek.getTime() - epochStart.getTime()) / (7 * 24 * 60 * 60 * 1000));
  
  // Create a seeded random function based on the week number
  const seed = weeksSinceEpoch;
  
  // Simple seeded random number generator
  const seededRandom = (seed: number) => {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
  };
  
  // Create a shuffled array using the seeded random (Fisher-Yates algorithm)
  const shuffledRecipes = [...filteredRecipes];
  for (let i = shuffledRecipes.length - 1; i > 0; i--) {
    const randomValue = seededRandom(seed + i + 1);
    const j = Math.floor(randomValue * (i + 1));
    [shuffledRecipes[i], shuffledRecipes[j]] = [shuffledRecipes[j], shuffledRecipes[i]];
  }
  
  // Return 7 different recipes for the week (one for each day)
  return shuffledRecipes.slice(0, 7);
}